import {
  SET_SELECTED_PROBABILITIES_HIPPODROME,
  GET_HORSE_RACE_PROBABILITIES_HIPPODROMES,
  GET_HORSE_RACE_PROBABILITIES_HIPPODROMES_SUCCESS,
  GET_HORSE_RACE_PROBABILITIES_HIPPODROMES_FAILURE,
  GET_HORSE_RACE_PROBABILITIES,
  GET_HORSE_RACE_PROBABILITIES_FAILURE,
  GET_HORSE_RACE_PROBABILITIES_SUCCESS,
  SET_SELECTED_HORSE_RACE_PROBABILITIES,
  HORSE_RACING_WS_PROBABLES_UPDATE
} from 'Store/constants';

const initialState = {
  probabilities: {
    data: [],
    selectedLeg: {},
    isLoading: false,
    error: null
  },
  hippodromes: {
    data: [],
    selectedHippodrome: {},
    isLoading: false,
    error: null,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_HORSE_RACE_PROBABILITIES:
      return { ...state, probabilities: { ...state.probabilities, isLoading: action.payload.isLoading, error: null } };
    case SET_SELECTED_HORSE_RACE_PROBABILITIES:
      return { ...state, probabilities: { ...state.probabilities, selectedLeg: action.payload } };
    case GET_HORSE_RACE_PROBABILITIES_SUCCESS:
      return { ...state, probabilities: { ...state.probabilities, data: action.payload, isLoading: false, error: null } };
    case GET_HORSE_RACE_PROBABILITIES_FAILURE:
      return { ...state, probabilities: { ...state.probabilities,  isLoading: false, error: action.payload } };

    case GET_HORSE_RACE_PROBABILITIES_HIPPODROMES:
      return { ...state, hippodromes: { ...state.hippodromes, isLoading: true, error: null } };
    case SET_SELECTED_PROBABILITIES_HIPPODROME:
      return { ...state, hippodromes: { ...state.hippodromes, selectedHippodrome: action.payload } };
    case GET_HORSE_RACE_PROBABILITIES_HIPPODROMES_SUCCESS:
      return { ...state, hippodromes: { ...state.hippodromes, data: action.payload, isLoading: false, error: null } };
    case GET_HORSE_RACE_PROBABILITIES_HIPPODROMES_FAILURE:
      return { ...state, hippodromes: { ...state.hippodromes, isLoading: false, error: action.payload } };
    
    case HORSE_RACING_WS_PROBABLES_UPDATE:
      return {
        ...state, probabilities: { ...state.probabilities, data: action.payload.cloneProbablesList, selectedLeg: action.payload.cloneProbablesList.find(x => +x.raceNo === +state.probabilities.selectedLeg.raceNo) },
       
      };
    default:
      return state;
  }
};